import { EMPTY_STRING } from '@constants';
import { Nullable } from '@customTypes';

export const getStringWithVariable = (str: string, variableKey: string, variable?: Nullable<string>) => {
  if (!str) return EMPTY_STRING;
  if (!variable) return str;

  const regex = new RegExp(variableKey, 'g');

  return str.replace(regex, variable);
};
